import { type ListarMensajesComprasAgilesResponse, type MensajeCompraAgil } from './api.schema';
import { type ListarMensajesComprasAgilesUi } from './ui.schema';

export { 
  ListarMensajesComprasAgilesResponseSchema,
  type ListarMensajesComprasAgilesResponse,
  type MensajeCompraAgil
} from './api.schema';

export { 
  ListarMensajesComprasAgilesUiSchema,
  type ListarMensajesComprasAgilesUi
} from './ui.schema';

export const transformMensajesComprasAgilesApiToUi = (
  response: ListarMensajesComprasAgilesResponse
): ListarMensajesComprasAgilesUi => {
  return response.map((mensaje: MensajeCompraAgil) => ({
    id: mensaje.id || '',
    fecha_creacion: mensaje.fecha_creacion || '',
    mensaje: mensaje.mensaje || '',
    activo: mensaje.activo || false,
    usuario_autor: mensaje.usuario_autor || ''
  }));
}; 